import React from 'react';
import {motion} from 'framer-motion'
import { useInView } from 'react-intersection-observer';
function AboutSection({ reverse = false, image, header, text, gradient = "from-[#1A1A2E] via-[#0F0F23] to-[#1A1A2E]" }) {
    var ximg = -100
    var otherX = -1 * ximg
    if (reverse) {
        ximg = 100;
        otherX = -1 * ximg;
    }
    const [ref,InView] = useInView({
        threshold:0.7,
        triggerOnce: true,
    })
    return (
        <div className="w-full items-center gap-8 px-6 bg-gradient-to-br from-[#1A1A2E] via-[#0F0F23] to-[#1A1A2E] rounded-lg p-6 shadow-lg border border-purple-500/20">

      {/* Image Section */}
            <motion.div className={`${reverse ? 'md:order-2' : 'md:order-1'} mb-4`}
            initial={{opacity:0,x:ximg}}
            animate={InView ? {opacity:1,x:0} : {}}
            transition={{duration:2}}
            >
                <img src={image} alt={header} className="w-full h-48 object-cover rounded-md" />
            </motion.div>

      {/* Text Section */}
            <motion.div ref={ref} className={`${reverse ? 'md:order-1' : 'md:order-2'}`}
            initial={{opacity:0,x:otherX}}
            animate={InView ? {opacity:1,x:0} : {}}
            transition={{duration:2}}
            >
                <p className="text-lg text-gray-300 leading-relaxed">{text}</p>
            </motion.div>
        </div>
    );
}

export default AboutSection;

